export default "__VITE_ASSET__DZAf8Ugt__"